type RoutesType = { readonly id: string, readonly path: string }

type BrandProps = { readonly brandId: string }
type CampaignProps = { readonly campaignId: string } & BrandProps

const routes = [
  // New routes (begin with /a/)
  { id: 'campaignSearch', path: '/a/campaigns/:campaignId/search', toLink: (props: CampaignProps) => `/a/campaigns/${props.campaignId}/search?brandId=${props.brandId}` },
  { id: 'campaignJournalists', path: '/a/campaigns/:campaignId/journalists', toLink: (props: CampaignProps) => `/a/campaigns/${props.campaignId}/journalists?brandId=${props.brandId}` },
  { id: 'campaignSettings', path: '/a/campaigns/:campaignId/settings', toLink: (props: CampaignProps) => `/a/campaigns/${props.campaignId}/settings?brandId=${props.brandId}` },
  { id: 'calendar', path: '/a/calendar', toLink: (props: BrandProps) => `/a/calendar?brandId=${props.brandId}` },
  // TODO 404 for /a/*

  // Legacy routes
  { id: 'campaignHome', path: '/campaigns/:campaignId', toLink: (props: CampaignProps) => `/campaigns/${props.campaignId}?brandId=${props.brandId}` },
  { id: 'emailInbox', path: '/emails', toLink: (props: BrandProps) => `/emails?brandId=${props.brandId}` },
  { id: 'tutorials', path: '/tutorials', toLink: (props: BrandProps) => `/tutorials?brandId=${props.brandId}` },
  { id: 'lessons', path: '/lessons', toLink: (props: BrandProps) => `/lessons?brandId=${props.brandId}` },
  { id: 'unlinkedMentions', path: '/unlinked_mention', toLink: (props: BrandProps) => `/unlinked_mention?brandId=${props.brandId}` },
  { id: 'brokenLinkBuilding', path: '/broken_link_building', toLink: (props: BrandProps) => `/broken_link_building?brandId=${props.brandId}` },
  { id: 'legacySearch', path: '/search_results', toLink: (props: BrandProps) => `/a/search?brandId=${props.brandId}` },
  { id: 'legacy', path: '*' },
] as const

export type RouteKey = (typeof routes)[number]['id']

// Defining as a type to enforce value type of routes without
// removing type information for the keys. Need to export otherwise
// TS will complain that it's not in use
type EnforceRoutesType<T extends ReadonlyArray<RoutesType>> = T;
export const enforcedRoutes: EnforceRoutesType<typeof routes> = routes

export const getRoutes = () => routes
export const routesByKey = routes.reduce((acc, route) => {
  acc[route.id] = route
  return acc
}, {} as Record<RouteKey, RoutesType>)


export type Route = (typeof routes)[number];

// Extract valid `id` values as a union type
export type RouteId = Route['id'];

// Create a mapped return type based on the route ID
export type RouteById<T extends RouteId> = Extract<Route, { id: T }>;

// Define your function to filter by id
export const getRouteById = <T extends RouteId>(id: T): RouteById<T> => {
  return routes.find(route => route.id === id)! as RouteById<T>;
};